/**
 * customer.ts Common Script File
 *
 * @project Codendot
 * @company Codendot <https://codendot.com>
 * @author Yahya Al Omar <yahya.a@codendot.com>
 * @since Thursday, November 17, 2022, 11:15 AM GMT+2
 *
 */
import AOS from 'aos';
import 'aos/dist/aos.css';


(() => {

    function main() {
        // initialize aos animation lib
        AOS.init({
            once: true,
            duration: 650, // values from 0 to 3000, with step 50ms
        });

        // Get the body element
        const body = document.querySelector('body');
        // const loader = document.querySelector('#loader-wrapper') as HTMLElement;

        // Remove the "loader-init" class and add the "loaded" class to the body element
        body?.classList.remove('loader-init');
        body?.classList.add('loaded');
        // setTimeout(() => {
        //     loader.style.display = 'none';
        // }, 400);
        // Bind a "beforeunload" event to the window object
        window.addEventListener('beforeunload', function () {
            // Remove the "loaded" class and add the "reload" class to the body element
            body?.classList.remove('loaded');
            body?.classList.add('reload');
        });

        // window.addEventListener('scroll', function () {
        //     var header = document.querySelector('.header-wrapper') as HTMLElement;
        //     var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        //     if (scrollPosition > 20) {
        //         header.style.backgroundColor = '#ffffff';
        //     } else {
        //         header.style.backgroundColor = ''; // Reset to default background color
        //     }
        // });


    }

    document.addEventListener("readystatechange", async (event: any) => {
        if (event.target.readyState === 'complete') {
            main()
        }
    })




})()